import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';
import { ReportCreate } from '../models/reports.model';

import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ReportPlaceService {
  private apiService = inject(ApiService);
  private readonly apiUrl: string = environment.apiUrl;
  private http = inject(HttpClient);
  private pipe = new DatePipe('en-US');

  getReport(formData: ReportCreate): Observable<any> {
    if (formData.startDate) {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';
    }

    if (formData.endDate) {
      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.apiService.getAll(
      `report/getBusiestReservedWorkplaces?${create}`
    );
  }
  getDashboardReport(formData: ReportCreate): Observable<any> {
    return this.apiService.post(
      `dashboard/getBusiestReservedWorkplaces`,
      formData
    );
  }

  getReportPdf(formData: ReportCreate): Observable<Blob | any> {
    if (formData.startDate) {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';
    }

    if (formData.endDate) {
      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.http.get(
      `${this.apiUrl}report/getBusiestReservedWorkplacesPDF?${create}`,
      { responseType: 'blob' as 'json' }
    );
  }

  getReportCsv(formData: ReportCreate): Observable<Blob | any> {
    if (formData.startDate) {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';
    }

    if (formData.endDate) {
      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.http.get(
      `${this.apiUrl}report/getBusiestReservedWorkplacesCSV?${create}`,
      { responseType: 'blob' as 'json' }
    );
  }

  private createTexteQuery(formData: ReportCreate) {
    let text = '';
    if (formData.startDate) {
      text += 'startDate=' + formData.startDate;
    }
    if (formData.endDate) {
      if (text) {
        text += '&endDate=' + formData.endDate;
      } else {
        text += 'endDate=' + formData.endDate;
      }
    }
    if (formData.worker) {
      if (text) {
        text += '&worker=' + formData.worker;
      } else {
        text += 'worker=' + formData.worker;
      }
    }
    if (formData.buildingId) {
      if (text) {
        text += '&buildingId=' + formData.buildingId;
      } else {
        text += 'buildingId=' + formData.buildingId;
      }
    }

    if (formData.floorId) {
      if (text) {
        text += '&floorId=' + formData.floorId;
      } else {
        text += 'floorId=' + formData.floorId;
      }
    }

    if (formData.workplaceTypeId) {
      if (text) {
        text += '&workplaceTypeId=' + formData.workplaceTypeId;
      } else {
        text += 'workplaceTypeId=' + formData.workplaceTypeId;
      }
    }

    if (formData.workplaceId) {
      if (text) {
        text += '&workplaceId=' + formData.workplaceId;
      } else {
        text += 'workplaceId=' + formData.workplaceId;
      }
    }

    if (formData.businessId) {
      if (text) {
        text += '&businessId=' + formData.businessId;
      } else {
        text += 'businessId=' + formData.businessId;
      }
    }
    if (formData.filter) {
      if (text) {
        text += '&filter=' + formData.filter;
      } else {
        text += 'filter=' + formData.filter;
      }
    }
    return text;
  }
}
